module.exports = __webpack_public_path__ + "308ad1ddd2f6353f67d012f73e1200de.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/wasistgoldencity4.jpg
// module id = 915
// module chunks = 0